import type { Locale } from '@packages/config';

export const getNavigationDataCacheKey = (
  clientId: string,
  channel: 'web' | 'mob',
  locale: Locale,
  sliced: boolean,
): string => `nav-data-${clientId}-${locale}-${channel}-${sliced}`;
